import { render, staticRenderFns } from "./FormHeaderDemo.vue?vue&type=template&id=a8557180&scoped=true&"
import script from "./FormHeaderDemo.vue?vue&type=script&lang=js&"
export * from "./FormHeaderDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8557180",
  null
  
)

export default component.exports